/* eslint-disable no-nested-ternary */
import React from "react";
import { Spacing } from "../../../theme/Spacing";
import { Flex } from "../../../components/Flex";
import styled from "styled-components";
import { Controller, useFormContext } from "react-hook-form";
import { GetUserFormsDto } from "../../../model/form/dto/GetUserFormsDto";
import { AtiraSelect } from "../../../components/AtiraSelect";
import { Status } from "../../../model/shared/enum/Status.enum";
import { useTranslation } from "react-i18next";
import { SortOptions } from "../../../model/shared/enum/SortOptions.enum";
import { useAppDispatch, useAppSelector } from "../../../redux/store";
import { formActions } from "../../../redux/forms/form.slice";
import { userSliceSelectors } from "../../../redux/user/user.selector";
import omitBy from "lodash/omitBy";
import isNil from "lodash/isNil";
import { FormType } from "../../../model/form/types/FormType.enum";
import { TestIDs } from "../../../tests/types/testIds";

const FiltersWrapper = styled(Flex)`
  align-items: center;
  gap: ${Spacing.m};
  height: 3rem;
  padding: 0 ${Spacing.s};
  margin-inline-start: ${Spacing.s};
`;

export const UserFormsFilters: React.FC = () => {
  const { control, getValues } = useFormContext<GetUserFormsDto>();
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const userId = useAppSelector(userSliceSelectors.selectLoggedInUserId)!;

  const formStatsOptions = [
    {
      label: t("common.all"),
      value: null as any,
    },
  ].concat(
    Object.keys(Status).map((key) => ({
      label: t(`common.${key.toLowerCase()}`),
      value: Status[key as keyof typeof Status],
      "data-testid": TestIDs.forms.forms.filters.status.option(String(key)),
    })),
  );

  const formSortOptions = Object.keys(SortOptions).map((key) => ({
    label: t(`forms.filters.${key.toLowerCase()}`),
    value: SortOptions[key as keyof typeof SortOptions],
  }));

  const typeOptions = [{ value: null as any, label: t("common.all") }].concat(
    Object.keys(FormType).map((key) => ({
      label: t(`form.status.type.${key.toLowerCase()}`),
      value: key as FormType,
    })),
  );

  const onFilter = () => {
    dispatch(
      formActions.getForms({
        userId,
        ...omitBy(getValues(), isNil),
      }),
    );
  };

  return (
    <FiltersWrapper>
      <Controller
        control={control}
        name="active"
        render={({ field: { onChange, value } }) => (
          <AtiraSelect
            options={formStatsOptions}
            value={{
              label: !value
                ? t("common.all")
                : t(`common.${value?.toLowerCase()}`),
              value,
            }}
            onChange={(e) => {
              onChange(e);
              onFilter();
            }}
            className={TestIDs.forms.forms.filters.status.dropdown}
            containerStyle={{ width: "10rem" }}
          />
        )}
      />

      <Controller
        control={control}
        name="sort"
        render={({ field: { onChange, value } }) => (
          <AtiraSelect
            value={{
              label: t(`forms.filters.${value?.toLowerCase()}`),
              value,
            }}
            options={formSortOptions}
            onChange={(e) => {
              onChange(e);
              onFilter();
            }}
            containerStyle={{ width: "15rem" }}
          />
        )}
      />

      <Controller
        name="type"
        control={control}
        render={({ field: { onChange, value } }) => (
          <AtiraSelect
            value={{
              label: value
                ? t(`form.status.type.${value?.toLowerCase()}`)
                : t("common.all"),
              value,
            }}
            options={typeOptions}
            onChange={onChange}
            containerStyle={{ width: "15rem" }}
          />
        )}
      />
    </FiltersWrapper>
  );
};
